var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.profile_edit") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 no-gutters" },
            [_c("back-button")],
            1
          ),
          _vm._v(" "),
          _vm.activateSpinner ? _c("spinner") : _vm._e(),
          _vm._v(" "),
          !_vm.activateSpinner
            ? _c(
                "form-accordion",
                {
                  attrs: {
                    title: _vm.$t("administration.profile_info"),
                    isTitleUpperCase: false,
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "12" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              inputLabel: _vm.$t("administration.label"),
                              placeholderValue: _vm.$t("administration.label"),
                            },
                            model: {
                              value: _vm.libelle,
                              callback: function ($$v) {
                                _vm.libelle = $$v
                              },
                              expression: "libelle",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("administration.right"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.rightList, function (right, index) {
                        return _c(
                          "b-col",
                          {
                            key: index,
                            staticClass: "form-group",
                            attrs: { sm: "4" },
                          },
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: { value: 1, "unchecked-value": 0 },
                                model: {
                                  value: _vm.rightList[index].state,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.rightList[index], "state", $$v)
                                  },
                                  expression: "rightList[index].state",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "rights.db_rights." + right.name
                                      ) ===
                                        "rights.db_rights." + right.name
                                        ? right.name
                                        : _vm.$t(
                                            "rights.db_rights." + right.name
                                          )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.activateSpinner
            ? _c(
                "b-row",
                {
                  staticClass:
                    "accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters",
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.changeProfil()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-save" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }